export default __webpack_public_path__ + "static/media/horror-skulls.0182581a.jpg";